import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=10d51888&scoped=true"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=10d51888&prod&scoped=true&lang=css"
import style1 from "./AppDrawer.vue?vue&type=style&index=1&id=10d51888&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d51888",
  null
  
)

export default component.exports